import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin, ChevronDown, ChevronUp, Users } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Link } from 'react-router-dom';

const OurAgents = () => {
  const { language } = useLanguage();
  const [expandedAgent, setExpandedAgent] = useState(null);

  const toggleAgent = (id) => {
    setExpandedAgent(expandedAgent === id ? null : id);
  };

  // Licensed Insurance Agents - Gabriel J. Palerm first as Founder & President, then agents
  const agentsData = [
  {
    id: 1,
    name: "Gabriel J Palerm",
    title: {
      en: "Founder & President",
      es: "Fundador y Presidente"
    },
    origin: { city: "San Juan", country: "Puerto Rico" },
    email: "palermg@palerminsurance.com",
    phone: "+14694348287",
    phoneDisplay: "+1 (469) 434-8287",
    isOfficePhone: true,
    npn: "6878201",
    photo: "/images/team/gabriel-palerm.png"
  },
  {
    id: 2,
    name: "Marilyn Garcia Rivera",
    origin: { city: "Carolina", country: "Puerto Rico" },
    email: "mgarcia@palerminsurance.com",
    phone: "+17873409073",
    phoneDisplay: "+1 (787) 340-9073",
    npn: "19336061",
    photo: "/images/team/marilyn-garcia.png"
  },
  {
    id: 3,
    name: "Deysi Hernandez-Vielma",
    origin: { city: "Caracas", country: "Venezuela" },
    email: "dvielma@palerminsurance.com",
    phone: "+12147183685",
    phoneDisplay: "+1 (214) 718-3685",
    npn: "20580778",
    photo: "/images/team/deysi-hernandez.png"
  },
  {
    id: 4,
    name: "Ircania Diaz-Jumelles",
    origin: { city: "Santo Domingo", country: "República Dominicana" },
    email: "idiaz@palerminsurance.com",
    phone: "+14694348287",
    phoneDisplay: "+1 (469) 434-8287",
    isOfficePhone: true,
    npn: "20775719",
    photo: "/images/team/ircania-diaz.png"
  },
  {
    id: 5,
    name: "Rene Maza-Fleites",
    origin: { city: "San Juan", country: "Puerto Rico" },
    email: "rmaza@palerminsurance.com",
    phone: "+17875507029",
    phoneDisplay: "+1 (787) 550-7029",
    npn: "6873986",
    photo: "/images/team/rene-maza.png"
  },
  {
    id: 6,
    name: "Aznarepse Palacios",
    origin: { city: "Maracay", country: "Venezuela" },
    email: "apalacios@palerminsurance.com",
    phone: "+16824072389",
    phoneDisplay: "+1 (682) 407-2389",
    npn: "19504588",
    photo: "/images/team/aznarepse-palacios.png"
  },
  {
    id: 7,
    name: "Mariolga Lopez-Castillo",
    origin: { city: "Yaracuy", country: "Venezuela" },
    email: "mlopez@palerminsurance.com",
    phone: "+14694639672",
    phoneDisplay: "+1 (469) 463-9672",
    npn: "21173850",
    photo: "/images/team/mariolga-lopez.png"
  },
  {
    id: 8,
    name: "Katherine Jimenez",
    origin: { city: "Macuyin", country: "Venezuela" },
    email: "kjimenez@palerminsurance.com",
    phone: "+14694348287",
    phoneDisplay: "+1 (469) 434-8287 x 102",
    extension: "102",
    npn: "19934048",
    photo: "https://customer-assets-lxgj4vgw.emergentagent.net/job_dc74b56d-b401-41b5-907f-23da31e328be/artifacts/93ba26ee48a8964e_image.png"
  },
  {
    id: 9,
    name: "T Wayne Johnson",
    origin: { city: "Greensboro", country: "North Carolina, Estados Unidos" },
    email: "twjohnson@palerminsurance.com",
    phone: "+19196253046",
    phoneDisplay: "+1 (919) 625-3046",
    npn: "6591578",
    photo: null
  },
  {
    id: 10,
    name: "Pierre Whiteside",
    specialty: {
      en: "Trucking Insurance Specialist",
      es: "Especialista en Seguros de Trucking"
    },
    origin: { city: "Clinton, Mississippi", country: "Estados Unidos" },
    email: "pwhiteside@palerminsurance.com",
    phone: "+12142800339",
    phoneDisplay: "+1 (214) 280-0339",
    npn: "18292776",
    photo: "/images/team/pierre-whiteside.png"
  }
];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <section className="bg-gradient-to-r from-blue-700 to-blue-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-white/10 p-4 rounded-full mb-6">
              <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
              {language === 'en' ? 'Our Agents' : 'Nuestros Agentes'}
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-4">
              {language === 'en' 
                ? 'Meet Our Professional Insurance Team' 
                : 'Conozca Nuestro Equipo Profesional de Seguros'}
            </p>
            <p className="text-lg text-blue-50">
              {language === 'en'
                ? 'Our experienced agents are here to help you find the right insurance coverage for your needs. Contact any of our team members directly for personalized assistance.'
                : 'Nuestros agentes experimentados están aquí para ayudarlo a encontrar la cobertura de seguro adecuada para sus necesidades. Contacte a cualquiera de los miembros de nuestro equipo directamente para asistencia personalizada.'}
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
            {agentsData.map((agent) => (
              <Card
                key={agent.id}
                className="hover:shadow-xl transition-all duration-300 border-none bg-white"
              >
                <CardContent className="p-6">
                  {agent.photo ? (
                    <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-4 border-blue-100">
                      <img 
                        src={agent.photo} 
                        alt={agent.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="w-24 h-24 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center mx-auto mb-4">
                      <span className="text-3xl font-bold text-white">
                        {agent.name.split(' ').map(n => n[0]).join('').substring(0, 2)}
                      </span>
                    </div>
                  )}

                  <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
                    {agent.name}
                  </h3>

                  {agent.title && (
                    <p className="text-sm font-semibold text-blue-700 text-center mb-2">
                      {agent.title[language]}
                    </p>
                  )}

                  {agent.specialty && (
                    <p className="text-sm italic text-blue-700 text-center mb-2">
                      {agent.specialty[language]}
                    </p>
                  )}

                  <p className="text-sm text-gray-600 text-center mb-4">
                    <span className="font-semibold">{language === 'en' ? 'From:' : 'De:'}</span>{' '}
                    {agent.origin.city}, {agent.origin.country}
                  </p>

                  <div className="space-y-3">
                    {agent.email && (
                      <a
                        href={`mailto:${agent.email}`}
                        className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 transition-colors"
                      >
                        <Mail className="w-4 h-4 flex-shrink-0" />
                        <span className="break-all">{agent.email}</span>
                      </a>
                    )}

                    {agent.email === null && (
                      <p className="text-sm text-gray-500 italic text-center">
                        {language === 'en' ? 'Contact via main office' : 'Contactar vía oficina principal'}
                      </p>
                    )}

                    {agent.phone && (
                      <a
                        href={`tel:${agent.phone}`}
                        className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 transition-colors"
                      >
                        <Phone className="w-4 h-4 flex-shrink-0" />
                        <span>
                          {agent.isOfficePhone 
                            ? (language === 'en' ? 'Call our office: ' : 'Llamar a la oficina: ')
                            : ''}{agent.phoneDisplay}
                        </span>
                      </a>
                    )}
                  </div>

                  {agent.npn && (
                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <p className="text-xs text-gray-500 text-center">
                        <span className="font-semibold">NPN:</span> {agent.npn}
                      </p>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-12 text-center bg-blue-50 p-6 rounded-lg max-w-4xl mx-auto">
            <p className="text-sm text-gray-700">
              <svg className="inline-block w-5 h-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <strong>{language === 'en' ? 'Note:' : 'Nota:'}</strong>{' '}
              {language === 'en'
                ? 'Click email or phone to get in touch with any of our agents.'
                : 'Haga clic en el correo electrónico o teléfono para ponerse en contacto con cualquiera de nuestros agentes.'}
            </p>
          </div>

          {/* Join Our Team CTA */}
          <div className="mt-16 text-center">
            <Card className="max-w-3xl mx-auto border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-white shadow-xl">
              <CardContent className="p-8 md:p-12">
                <div className="flex items-center justify-center gap-3 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center">
                    <Users className="w-8 h-8 text-white" />
                  </div>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  {language === 'en' ? 'Join Our Team' : 'Únete a nuestro equipo'}
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                  {language === 'en'
                    ? 'Are you a passionate insurance professional? Explore opportunities with Palerm Insurance Agency.'
                    : '¿Eres un profesional de seguros apasionado? Explora oportunidades con Palerm Insurance Agency.'}
                </p>
                <Link
                  to="/join-our-team"
                  className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  {language === 'en' ? 'Learn More' : 'Conocer más'}
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurAgents;